export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
  tone: 'primary' | 'accent' | 'secondary';
}

export const categories: Category[] = [
  { name: '玄幻', slug: 'xuanhuan', icon: 'ri-sun-foggy-line', count: 1286, tone: 'primary' },
  { name: '武侠', slug: 'wuxia', icon: 'ri-sword-line', count: 976, tone: 'accent' },
  { name: '古风', slug: 'gufeng', icon: 'ri-landscape-line', count: 812, tone: 'secondary' },
  { name: '都市', slug: 'dushi', icon: 'ri-building-2-line', count: 1450, tone: 'primary' },
  { name: '科幻', slug: 'kehuan', icon: 'ri-rocket-2-line', count: 698, tone: 'accent' },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', count: 534, tone: 'secondary' },
  { name: '热血', slug: 'rexue', icon: 'ri-fire-line', count: 1108, tone: 'primary' },
  { name: '恋爱', slug: 'lianai', icon: 'ri-heart-3-line', count: 892, tone: 'accent' },
  { name: '治愈', slug: 'zhiyu', icon: 'ri-sun-line', count: 476, tone: 'secondary' },
  { name: '美食', slug: 'meishi', icon: 'ri-restaurant-line', count: 389, tone: 'primary' },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-happy-line', count: 764, tone: 'accent' },
  { name: '冒险', slug: 'maoxian', icon: 'ri-compass-line', count: 621, tone: 'secondary' },
];